var _defs, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900.07 580.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8f8ff;}.cls-2{fill:#fff;}.cls-3{fill:none;stroke:#bac6f2;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M548,513S380,309,568,257,822,417,950,423s278-80,318-80,112,4,108,74-56,134-58,168,46,126,54,148,18,84-26,88c-22.52,2-151,27-325-24-131.67-38.59-337.76,28-385.81,28a74.9,74.9,0,0,1-43.45-13.76C556.44,786.13,500.27,723.06,550,593,576,525,548,513,548,513Z",
    transform: "translate(-478.92 -248.8)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 237.08,
    cy: 246.2,
    r: 51
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 175.08,
    cy: 255.2,
    r: 34
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 291.08,
    cy: 256.2,
    r: 33
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 702.08,
    cy: 402.2,
    r: 51
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 639.08,
    cy: 407.2,
    r: 34
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 758.08,
    cy: 411.2,
    r: 33
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 152.08,
    cy: 470.2,
    r: 34
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 192.08,
    cy: 476.2,
    r: 24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M712,643s23-29,47,3c0,0,23-34,37-5",
    transform: "translate(-478.92 -248.8)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M656,616.85S672.52,596,689.75,619c0,0,16.52-24.42,26.57-3.59",
    transform: "translate(-478.92 -248.8)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1189,455.85s16.52-20.83,33.75,2.15c0,0,16.52-24.42,26.57-3.59",
    transform: "translate(-478.92 -248.8)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M549,353.85S565.52,333,582.75,356c0,0,16.52-24.42,26.57-3.59",
    transform: "translate(-478.92 -248.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg12);
export default __webpack_public_path__ + "static/media/bg12.80a87f5c371274ffa0828140b9ef2ed3.svg";
export { ForwardRef as ReactComponent };